<template>
  <component
    :is="item.fields.link?.value.href && !isVideo(item.fields) ? 'a' : 'div'"
    class="header-media-item-fi"
    :class="item.fields.link?.value.href ? 'header-media-item-fi--link' : null"
    :href="item.fields.link?.value.href ? item.fields.link.value.href : null"
  >
    <div
      v-if="!isVideo(item.fields)"
      class="header-media-item-fi__image"
    >
      <picture>
        <source
          v-if="item.fields.imageMobile?.value?.src"
          media="(max-width: 767px)"
          :srcset="
            appendParams(
              `${getProxySrc(item.fields.imageMobile.value.src)}`,
              'h=260&func=crop&org_if_sml=0',
            )
          "
        />
        <source
          v-if="item.fields.imageTablet?.value?.src"
          media="(max-width: 1439px)"
          :srcset="
            appendParams(
              `${getProxySrc(item.fields.imageTablet.value.src)}`,
              'h=386&func=crop&org_if_sml=0',
            )
          "
        />
        <img
          v-if="item.fields.image?.value?.src"
          :src="
            appendParams(
              `${getProxySrc(item.fields.image.value.src)}`,
              'h=648&func=crop&org_if_sml=0',
            )
          "
          :alt="item.fields.image.value.alt || item.fields.headline?.value || null"
          :loading="eager ? 'eager' : undefined"
          :fetchpriority="eager ? 'high' : undefined"
        />
      </picture>
    </div>
    <template v-else>
      <video-player-fi
        class="header-media-item-fi__video"
        :fields="item.fields"
        :show-hide-delay="1000"
        :reset-video="slideChanged"
        preview-params="func=crop&org_if_sml=0"
        @video="videoEvent"
      />
    </template>
  </component>
</template>

<script setup lang="ts">
import VideoPlayerFi from '@/components/video-player-fi/VideoPlayerFi.vue';
import { useCloudImage } from '@/composables/cloudImage';
import { useVideo } from '@/composables/video';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'HeaderMediaItemFi' });

withDefaults(
  defineProps<{
    item?: Record<string, any>;
    slideChanged?: boolean;
    eager?: boolean;
  }>(),
  {
    item: () => ({}),
    slideChanged: false,
    eager: false,
  },
);

const emit = defineEmits<{
  'pause-slider': [value: boolean];
}>();

const { isVideo } = useVideo();
const { getProxySrc, appendParams } = useCloudImage();
const navigationStore = useNavigationStore();

const videoEvent = (event: string) => {
  if (event === 'beforePlaying') {
    navigationStore.setShowBrandArea(false);
    emit('pause-slider', true);
  }

  if (event === 'hid') {
    navigationStore.setShowBrandArea(true);
    emit('pause-slider', false);
  }
};
</script>

<style src="./header-media-item-fi" />
